export default [
  {
    code: "es",
    name: "Español",
  },
  {
    code: "en",
    name: "English",
  },
];
